<script setup>
import {mapErrors} from "@/utilities";
import {useForm, usePage} from "@inertiajs/vue3";
import {computed, inject, onMounted,} from "vue";
import {useI18n} from "vue-i18n";

const route = inject("route");
const {n, t} = useI18n();
const companyDetails = computed(() => usePage().props.company_details);

const props = defineProps({
  form: Object,
  shippingRateOptions: Array,
});

onMounted(() => {
  if (props.shippingRateOptions.length === 1) {
    props.form.shipping_rate_id = props.shippingRateOptions[0].id;
    submitShippingRateForm();
  }
});

function submitShippingRateForm() {
  useForm({shipping_rate_id: props.form.shipping_rate_id}).post(route("public.shopping-cart-shipping-rate.store"), {
    preserveScroll: true,
    onError: (errors) => (props.form.errors = mapErrors(errors)),
  });
}

const shippingRateDisplayOptions = computed(() => {
  return props.shippingRateOptions.map((rate) => {
    return {label: rate.name, value: rate.id};
  });
});

const companyAddress = computed(() => {
  if (companyDetails.value.street &&
      companyDetails.value.postal_code &&
      companyDetails.value.city) {
    return `${companyDetails.value.street}, ${companyDetails.value.postal_code} ${companyDetails.value.city}`;
  }

  return '';
})

const getShippingRatePrice = (id) => {
  const rate = props.shippingRateOptions.find((option) => option.id === id);
  if (!rate) {
    return '';
  }

  if (rate?.price === 0) {
    return t("Free");
  }

  return n(rate.price / 100, "currency")
};


</script>

<template>
    <h2 class="text-2xl font-bold uppercase lg:text-3xl xl:leading-12">
        {{ $t("Delivery options") }}
    </h2>
    <FormKit
        v-model="form.shipping_rate_id"
        type="radio"
        :options="shippingRateDisplayOptions"
        :errors="form.errors?.shipping_rate_id"
        :value="form.shipping_rate_id"
        :classes="{wrapper:'border border-[#B0B0B0] p-4 cursor-pointer' }"
        @update:model-value="submitShippingRateForm()"
    >
        <template #label="context">
            <div class="flex w-full flex-col justify-between gap-px md:flex-row">
                <div>
                    <span>{{ context.option.label }}</span>


                    <span
                        v-if="context.option.label === $t('Pick-up') && companyAddress"
                        class="text-xs md:text-base"
                    >
                        &nbsp;({{ companyAddress }})
                    </span>
                </div>
                <div class="font-bold uppercase">
                    {{ getShippingRatePrice(context.option.value) }}
                </div>
            </div>
        </template>
    </FormKit>
</template>
